import { fromPromise } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

export const refreshBag = fromPromise<void>(async () => {
  throw new Error('`refreshBag` actor is not provided.');
});
